/* @flow */
import * as React from 'react';
import PhoneCallsLogTableRow from 'phoneCalls/components/PhoneCallsLogTableRow';
import Table from 'components/Table';

import type { PhoneCall } from 'phoneCalls/components/PhoneCallsLogTableRow';

import './styles/PhoneCallsLogTable.scss';

type Props = {
  phoneCalls: PhoneCall[],
};

function PhoneCallsLogTable(props: Props) {
  // The filter covers the case where a caller/e becomes disconnected and search returns null for otherUser
  const phoneCallsWithOtherUser = props.phoneCalls.filter(c => !!c.otherUser);

  return (
    <Table actionsColumn className="PhoneCallsLogTable">
      <tbody>
        {phoneCallsWithOtherUser.map(c => (
          <PhoneCallsLogTableRow key={c.uuid} phoneCall={c} />
        ))}
      </tbody>
    </Table>
  );
}

export default PhoneCallsLogTable;
